import React from 'react';
import ReactDOM from 'react-dom';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import Arrow from '-!svg-react-loader!./assets/img/arrow.svg?name=Arrow';
import Check from '-!svg-react-loader!./assets/img/check.svg?name=Check';
import AddIcon from '-!svg-react-loader!./assets/img/add.svg?name=AddIcon';
import RemoveIcon from '-!svg-react-loader!./assets/img/remove.svg?name=RemoveIcon';
import './collapse.scss';

class Collapse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick() {
    const { show } = this.state;
    const { withAction } = this.props;
    this.setState({ show: !show });

    if(!show && withAction){
      const element = document.getElementById('OfferDetails-padding');
      ReactDOM.findDOMNode(element).style.minHeight = '200vh';
    } else if (show && withAction){
      const element = document.getElementById('OfferDetails-padding');
      ReactDOM.findDOMNode(element).style.minHeight = '0vh';
    }

  }

  handleOnHover() {
    this.setState({ hover: !this.state.hover });
  }

  handleOnActionClick(itemCode) {
    this.props.onActionClick(itemCode);

    if (this.props.closeOnAction) {
      this.setState({ show: false });
    }
  }

  render() {
    const { title, list, showPrice, priceMessage, info, withAction } = this.props;
    const { show } = this.state;
    const hasGroups = list.length > true;

    return (
      <div className={'ui-collapse-list'}>
        <div className={'ui-collapse-pointer'}  onClick={this.handleOnClick}>
        <div className={'ui-collapse-title'}> {title} </div>
        <span className={'float-right field-icon'}> <Arrow/> </span>
        </div>
        {
          show &&
            <>
          <div className={'ui-collapse-content'}>
            {list.map((elem, elemKey) =>
              <div className={'ui-collapse-items'} key={elemKey}>
                {
                  hasGroups &&
                  <span className={'ui-collapse-title'}>{elem.title}</span>
                }
                <ul className={'items'}>
                  {elem.items.map((item, key) =>
                    <li className={'item'} key={key}>
                      <Row>
                      <Col md={10}>{item.description}</Col>
                      <Col md={2} className="text-right font-weight-bold nowrap">
                        {
                          showPrice &&
                          <>
                            + {parseInt(item.price).toLocaleString('it')}&euro;
                            {
                              withAction && !item.selected && <AddIcon className={'action-icon'} onClick={() => this.handleOnActionClick(item.code)}/>
                            }
                            {
                              withAction && item.selected && <RemoveIcon className={'action-icon-remove'} onClick={() => this.handleOnActionClick(item.code)}/>
                            }
                          </>
                        }
                        {
                          !showPrice &&
                          <>
                            {
                              ( parseInt(item.price) <= false && priceMessage.length > 0 ) &&
                              <>
                                {priceMessage} <Check/>
                              </>
                            }
                          </>
                        }
                      </Col>
                      </Row>
                    </li>,
                  )}
                </ul>
              </div>,
            )}
          </div>
              {
                info.length > 0 &&
                <div className={'ui-collapse-footer'}>{info}</div>
              }
          </>
        }
      </div>
    );
  }
}


Collapse.defaultProps = {
  list: [],
  showPrice: true,
  priceMessage: 'Di Serie',
  info: '',
  withAction: false,
  closeOnAction: false,
  onActionClick: () => {},
};

Collapse.propTypes = {
  title: PropTypes.string.isRequired,
  list: PropTypes.array,
  showPrice: PropTypes.bool,
  priceMessage: PropTypes.string,
  info: PropTypes.string,
  withAction: PropTypes.bool,
  closeOnAction: PropTypes.bool,
  onActionClick: PropTypes.func,
};

export default Collapse;
